import type { BlokProps } from "@trydig/storyblok";
import { BlokWrap } from "@/components/bloks/BlokWrap";
import {
	FeaturedCollectionAsset,
	type FeaturedCollectionAssetSide,
} from "@/components/ui/sections/FeaturedCollectionAsset";
import type { FeaturedCollectionAssetStoryblok } from "@/generated/sb/sb-types";
import { sbLink } from "@/lib/storyblok/link";
import { checkBlokBackground } from "@/lib/utils/isDarkMode";

export const FeaturedCollectionAssetBlok = ({
	blok,
}: BlokProps<FeaturedCollectionAssetStoryblok>) => {
	const linkHref = sbLink(blok.link)?.href;
	const side = (blok.side ?? "right") as FeaturedCollectionAssetSide;
	const bg = checkBlokBackground(blok);

	return (
		<BlokWrap editable={blok} asChild>
			<FeaturedCollectionAsset
				side={side}
				caption={blok.caption || undefined}
				heading={blok.heading || undefined}
				description={blok.description || undefined}
				linkLabel={blok.linkLabel || undefined}
				linkHref={linkHref}
				asset={blok.asset}
				bg={bg}
			/>
		</BlokWrap>
	);
};
